
import { useTranslation } from 'react-i18next';
import BookingForm from '../../../components/feature/BookingForm';

export default function ContactSection() {
  const { t } = useTranslation();

  return (
    <section id="contact" className="py-20 bg-gradient-to-br from-sand-50 via-white to-ocean-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div>
            <div className="inline-flex items-center space-x-2 bg-ocean-50 border border-ocean-200 px-4 py-2 rounded-full mb-5">
              <i className="ri-calendar-line text-ocean-500 text-sm"></i>
              <span className="text-ocean-600 text-sm font-medium">Réservation rapide</span>
            </div>
            <h2
              className="text-4xl md:text-5xl font-bold text-navy-800 mb-4"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              {t('contact.title')}{' '}
              <span className="text-ocean-500">{t('contact.titleHighlight')}</span>
            </h2>
            <p className="text-lg text-navy-600 mb-8 leading-relaxed">{t('contact.description')}</p>

            <div className="space-y-5 mb-8">
              <div className="flex items-start space-x-4 p-4 bg-white rounded-xl border border-sand-200 shadow-sm hover:shadow-md transition-shadow">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-ocean-400 to-ocean-600 rounded-xl flex-shrink-0 shadow-md">
                  <i className="ri-whatsapp-line text-xl text-white"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-navy-800 mb-1">{t('contact.whatsapp')}</h4>
                  <p className="text-navy-600 font-medium">+33 7 65 73 03 33</p>
                  <p className="text-xs text-navy-400 mt-0.5">Réponse rapide garantie</p>
                </div>
              </div>

              <div className="flex items-start space-x-4 p-4 bg-white rounded-xl border border-sand-200 shadow-sm hover:shadow-md transition-shadow">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-navy-700 to-navy-900 rounded-xl flex-shrink-0 shadow-md">
                  <i className="ri-mail-line text-xl text-white"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-navy-800 mb-1">{t('contact.email')}</h4>
                  <p className="text-navy-600">contact@hoplafrenchriviera.com</p>
                  <p className="text-xs text-navy-400 mt-0.5">Réponse sous 24h</p>
                </div>
              </div>

              <div className="flex items-start space-x-4 p-4 bg-white rounded-xl border border-sand-200 shadow-sm hover:shadow-md transition-shadow">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-coral-400 to-coral-600 rounded-xl flex-shrink-0 shadow-md">
                  <i className="ri-anchor-line text-xl text-white"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-navy-800 mb-1">{t('contact.homePort')}</h4>
                  <p className="text-navy-600">{t('contact.homePortValue')}</p>
                  <p className="text-xs text-navy-400 mt-0.5">Côte d&apos;Azur, France</p>
                </div>
              </div>
            </div>

            {/* Trust badges */}
            <div className="grid grid-cols-3 gap-3">
              {[
                { icon: 'ri-shield-check-line', label: 'Assurance incluse' },
                { icon: 'ri-award-line', label: 'Certifié qualité' },
                { icon: 'ri-customer-service-2-line', label: 'Support 7j/7' },
              ].map((badge, i) => (
                <div key={i} className="flex flex-col items-center p-3 bg-white rounded-xl border border-sand-200 text-center shadow-sm">
                  <div className="w-9 h-9 flex items-center justify-center">
                    <i className={`${badge.icon} text-xl text-ocean-500`}></i>
                  </div>
                  <span className="text-xs text-navy-600 font-medium mt-1 leading-tight">{badge.label}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-white rounded-2xl p-6 md:p-8 shadow-xl border border-sand-200 relative overflow-hidden">
            <div className="absolute top-0 right-0 w-40 h-40 bg-gradient-to-bl from-ocean-50 to-transparent rounded-bl-full pointer-events-none" />
            <div className="absolute bottom-0 left-0 w-32 h-32 bg-gradient-to-tr from-sand-100 to-transparent rounded-tr-full pointer-events-none" />
            <div className="relative z-10">
              <BookingForm />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
